import styled from "@emotion/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";
import useTranslation from "next-translate/useTranslation";
import { MouseEventHandler, ReactNode } from "react";

type Props = {
  clickable: boolean;
  collapsed?: boolean;
  onClick?: MouseEventHandler<Element>;
  variant?: TypographyProps["variant"];
  customCollapsedEllipsis?: ReactNode;
  color?: TypographyProps["color"];
};

export const ELLIPSIS_CLASSNAME = "RichTextViewerEllipsis";

const RichTextViewerDefaultEllipsis = ({
  variant,
  collapsed,
  color,
  clickable,
  customCollapsedEllipsis,
  onClick
}: Props): JSX.Element => {
  const { t } = useTranslation("common");

  const collapsedEllipsis = customCollapsedEllipsis ?? t("ellipsis_more");

  return (
    <Ellipsis
      onClick={onClick}
      variant={variant}
      color={color}
      className={ELLIPSIS_CLASSNAME}
      clickable={clickable}
    >
      {collapsed ? collapsedEllipsis : t("less")}
    </Ellipsis>
  );
};

export default RichTextViewerDefaultEllipsis;

const Ellipsis = styled(Typography, {
  shouldForwardProp: prop => prop !== "clickable"
})<{ clickable: boolean }>`
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};
  display: inline-block;
  margin-left: ${({ theme }) => theme.spacing(1)};
  pointer-events: ${({ clickable }) => (clickable ? "pointer" : "auto")};
`;

Ellipsis.defaultProps = {
  variant: "paragraphSecondary",
  color: "text.tertiary"
};
